import { Building2, Search, SlidersHorizontal, Sparkles } from 'lucide-react'
import { useMemo, useState } from 'react'
import { CompanyCard } from '../../components/companies/CompanyCard'
import { companies } from '../../data/demo'

export function CompanyMarketplacePage() {
  const [query, setQuery] = useState('')
  const [activeOnly, setActiveOnly] = useState(false)

  const filtered = useMemo(() => {
    const normalized = query.trim().toLowerCase()
    return companies.filter((company) => {
      if (activeOnly && !company.activeSponsor) return false
      if (!normalized) return true
      return [company.name, company.sector, company.city, company.region, ...company.sports, ...company.values]
        .join(' ')
        .toLowerCase()
        .includes(normalized)
    })
  }, [query, activeOnly])

  return <section className="section container company-marketplace">
    <div className="page-hero company-marketplace__hero">
      <span className="eyebrow">Entreprises</span>
      <h1>Découvrez les entreprises qui s’engagent</h1>
      <p>Consultez leur univers, leurs budgets et les opportunités qu’elles publient.</p>
    </div>

    <div className="company-searchbar">
      <Search size={20} />
      <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Entreprise, secteur, ville ou sport" aria-label="Rechercher une entreprise" />
      <button className={activeOnly ? 'is-active' : ''} onClick={() => setActiveOnly((value) => !value)}><SlidersHorizontal size={16} />Opportunités actives</button>
    </div>

    <div className="company-marketplace__summary"><span><Sparkles size={16} />{filtered.length} entreprises à découvrir</span><span><Building2 size={16} />Profils et opportunités de démonstration</span></div>

    {filtered.length > 0 ? <div className="company-grid-v4">{filtered.map((company) => <CompanyCard company={company} key={company.id} />)}</div> : <div className="company-empty"><Building2 /><h2>Aucune entreprise trouvée</h2><p>Essayez un autre secteur ou une autre ville.</p></div>}
  </section>
}
